export default "__VITE_PUBLIC_ASSET__c0dd4e32__"